//引入axios
import axios from 'axios'

import router from '../router/index'

import {
  Message
} from 'element-ui'

//判断是否是生产环境
var isPro = process.env.NODE_ENV === 'production' //process.env.NODE_ENV用于区分是生产环境还是开发环境

//根据环境不同导出不同的baseURL
let baseURL = isPro ? 'https://www.aghgzx.com' : 'https://www.aghgzx.com'
// let baseURL = isPro ? 'https://gyl.kswlll.com' : 'https://gyl.kswlll.com'
// let baseURL = isPro ? 'https://supply.aghgzx.com' : 'https://supply.aghgzx.com'
//创建一个新的axios实例
const service = axios.create({
  baseURL: baseURL,
  //设置超时时间，超过该时间就不会发起请求
  timeout: 30000
})
service.interceptors.request.use(
  config => {
    config.headers = {
      'Content-Type': 'application/json',//配置请求头
    }
    config.headers["token"] = localStorage.kstoken //配置token
    config.headers['Accept-Language'] = localStorage.language || "zh"
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  //请求成功处理
  response => {
    const res = response
    if (res.data.code === 1) {
      return res.data
    } else if(res.data.code === 0) {
      Message.error(res.data.msg)
      return res.data
    }else{
      return res.data
    }
  },
  error => {
    if (JSON.stringify(error).includes('timeout')) {
      Message.error(error.response.data.msg)
      if (error.response.data.code == '401') {
        localStorage.clear()

        setTimeout(() => {
          router.replace('/login/signIn')
        }, 1000);

      }
    }
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js